import {
    CREATE_INITIAL_STORAGE,
} from './constant';

/**
 * Create initial storage
 * @param syncNsfToSails
 */
export function createInitialStorage () {
    return {
        type: CREATE_INITIAL_STORAGE,
    };
}
